import type { getGuarantorsType } from '@/services/pre-enrollment/types';
import createFile from '@/utils/file-upload-function/createFile';
import type { GuarantorsValuesType } from './types';

const nationalityInitialValue = (
  currentGuarantor: getGuarantorsType | undefined,
) => {
  if (currentGuarantor) {
    if (currentGuarantor?.nationality === 'brasileira') {
      return 'brasileira';
    }
    return 'outra';
  }
  return '';
};

const pepChecked = (currentGuarantor: getGuarantorsType | undefined) => {
  if (currentGuarantor) {
    if (currentGuarantor.politically_exposed_person) {
      return 'true';
    }
    return 'false';
  }
  return '';
};

const guarantorsInitialFormValues = (
  currentGuarantor: getGuarantorsType | undefined,
): GuarantorsValuesType => {
  return {
    name: currentGuarantor?.name || '',
    marital_status: currentGuarantor?.marital_status || '',
    degree_of_relatedness: currentGuarantor?.degree_of_relatedness || '',
    degree_of_relatedness_other:
      currentGuarantor?.degree_of_relatedness_other || '',
    marital_regime: currentGuarantor?.marital_regime || '',
    email: currentGuarantor?.email || '',
    phone_number: currentGuarantor?.phone_number || '',
    birthdate: currentGuarantor?.birthdate || '',
    day: currentGuarantor?.birthdate.split('-')[2] || '',
    month: currentGuarantor?.birthdate.split('-')[1] || '',
    year: currentGuarantor?.birthdate.split('-')[0] || '',
    nationality: nationalityInitialValue(currentGuarantor),
    nationalityOther:
      currentGuarantor?.nationality &&
      currentGuarantor?.nationality !== 'brasileira'
        ? currentGuarantor?.nationality
        : '',
    birthplace: currentGuarantor?.birthplace || '',
    zipcode: currentGuarantor?.zipcode || '',
    state: currentGuarantor?.state || '',
    city: currentGuarantor?.city || '',
    neighborhood: currentGuarantor?.neighborhood || '',
    address: currentGuarantor?.address || '',
    residence_type: currentGuarantor?.residence_type || '',
    address_complement: currentGuarantor?.address_complement || '',
    residence_number: currentGuarantor?.residence_number || '',
    cpf: currentGuarantor?.cpf || '',
    rg: currentGuarantor?.rg || '',
    rg_issuing_body: currentGuarantor?.rg_issuing_body || '',
    rg_issuing_state: currentGuarantor?.rg_issuing_state || '',
    pep: pepChecked(currentGuarantor),
    proofOfAddress: currentGuarantor?.proof_of_residency_document_url
      ? createFile(
          currentGuarantor?.proof_of_residency_document_url.split(
            '_guarantor_',
          )[1],
        )
      : undefined,
    cpfFile: currentGuarantor?.cpf_document_url
      ? createFile(currentGuarantor?.cpf_document_url.split('_guarantor_')[1])
      : undefined,
    rgFile: currentGuarantor?.rg_document_url
      ? createFile(currentGuarantor?.rg_document_url.split('_guarantor_')[1])
      : undefined,
    selfieWithDocument: currentGuarantor?.document_selfie_url
      ? createFile(
          currentGuarantor?.document_selfie_url.split('_guarantor_')[1],
        )
      : undefined,
    sameAsMine: '',
    sameAsFirstGuarantor: '',
  };
};

export default guarantorsInitialFormValues;
